import {GetterTree} from "vuex";
import {RootState} from "@/store/types";
import {MembersState} from "@/store/member/types";
import _ from "lodash";

const getters: GetterTree<MembersState, RootState> = {
}

export default getters
